<template>
  <div v-if="isProMonthlyToAnnualBilledMonthlyUpgrade" class="opc-cart-item__text first-capitalize opc-next-renewal">
    {{ $t('billing.order_summary.next_renewal_date') }}
    <vloader :loading="isProratedLoading" :value="getProAnnualBilledMonthlyNextRenewalDate" />
    &nbsp;
    <zm-tooltip
      v-if="!isProratedLoading"
      :content="$t('billing.order_summary.next_renewal_date_tooltip')"
      role="button"
      aria-label="Learn more about Subscription Renewal Date"
    >
      <i class="zm-icon-info-outline" style="position: relative; top: -1px; color: #666487; font-size: 16px" />
    </zm-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import vloader from '@/views/config/shopping-cart/prorated/vloader.vue';
import proAnnualBilledMonthlyMixin from '@/plans/ZOOM_MEETING/mixin/pro-annual-billed-monthly';

export default {
  name: 'NextRenewalDate',
  mixins: [proAnnualBilledMonthlyMixin],
  components: { vloader },
  computed: {
    ...mapGetters(['isProratedLoading'])
  }
};
</script>

<style lang="scss" scoped>
.opc-next-renewal {
  color: var(--day-foreground-foreground-strong, #00031f);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
</style>
